import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertTitle, Box, Typography } from '@mui/material';

import Payment from '@/shared/types/order/payment.type';
import formatCurrency from '@/shared/utils/formatCurrency';

type RefundDetailsBoxProps = {
  payment: Payment;
};

const RefundDetailsBox: FC<RefundDetailsBoxProps> = ({ payment }) => {
  const { t } = useTranslation(['payments', 'common']);

  return (
    <Alert severity='info'>
      <AlertTitle>{t('payments:notice')}</AlertTitle>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography variant='body1'>
          {t('payments:transaction_amount')}:
        </Typography>
        <Typography variant='body1'>
          {formatCurrency(parseFloat(payment.transaction_amount))}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography variant='body1'>
          {t('payments:refunded_to_date')}:
        </Typography>
        <Typography variant='body1'>{payment.amount_refunded || 0}</Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography variant='body1'>{t('payments:remaining')}:</Typography>
        <Typography variant='body1'>
          {formatCurrency(
            parseFloat(payment.transaction_amount) -
              parseFloat(payment.amount_refunded || '0'),
          )}
        </Typography>
      </Box>
    </Alert>
  );
};

export default RefundDetailsBox;
